/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OrganizationsControllerCreateMutationRequest, OrganizationsControllerCreateMutationResponse, OrganizationsControllerCreate400, OrganizationsControllerCreate401, OrganizationsControllerCreate403 } from "../../models/organizationsController/OrganizationsControllerCreate";

function getOrganizationsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/organizations` as const }  
  return res
}

/**
 * @summary Create a new organization
 * {@link /api/v1/organizations}
 */
export async function organizationsControllerCreate(data?: OrganizationsControllerCreateMutationRequest, config: Partial<RequestConfig<OrganizationsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<OrganizationsControllerCreateMutationResponse, ResponseErrorConfig<OrganizationsControllerCreate400 | OrganizationsControllerCreate401 | OrganizationsControllerCreate403>, OrganizationsControllerCreateMutationRequest>({ method : "POST", url : getOrganizationsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}